// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/css/fonts/Viga-Regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/css/fonts/icomoon.eot?r44a6r", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/css/fonts/icomoon.ttf?r44a6r", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/css/fonts/icomoon.woff?r44a6r", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/css/fonts/icomoon.svg?r44a6r", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/images/background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/images/loader-white.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a, abbr, acronym, address, applet, article, aside, audio, b, big, blockquote, body, canvas, caption, center, cite, code, dd, del, details, dfn, div, dl, dt, em, embed, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, html, i, iframe, img, ins, kbd, label, legend, li, mark, menu, nav, object, ol, output, p, pre, q, ruby, s, samp, section, small, span, strike, strong, sub, summary, sup, table, tbody, td, tfoot, th, thead, time, tr, tt, u, ul, var, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
}

* {
  box-sizing: border-box;
  position: relative;
  outline: 0;
}

article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
  display: block;
}

body {
  line-height: 1;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
}

i {
  font-style: normal;
}

ul, ol {
  list-style: none;
}

h1, h2, h3, h4 {
  font-weight: normal;
}

@font-face {
  font-family: "vigaregular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "icomoon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-back, .icon-arrow-back, .icon-config, .icon-drinks, .icon-theme, .icon-close {
  color: #caa36c;
}

.icon-arrow-back {
  font-size: 16px;
}

.icon-check:before {
  content: "\\e90f";
}

.icon-edit-bold:before {
  content: "\\e90e";
}

.icon-painting:before {
  content: "\\e90b";
}

.icon-trash:before {
  content: "\\e90c";
}

.icon-qrcode:before {
  content: "\\e90d";
}

.icon-info:before {
  content: "\\e905";
}

.icon-sort:before {
  content: "\\e906";
}

.icon-close:before {
  content: "\\e907";
}

.icon-arrow-back:before {
  content: "\\e908";
}

.icon-edit:before {
  content: "\\e909";
}

.icon-add:before {
  content: "\\e90a";
}

.icon-theme:before {
  content: "\\e904";
}

.icon-arrow-down:before {
  content: "\\e903";
}

.icon-back:before {
  content: "\\e900";
}

.icon-config:before {
  content: "\\e901";
}

.icon-drinks:before {
  content: "\\e902";
}

html {
  height: 100%;
}

body {
  font: 62.5%/1 Arial, "Helvetica Neue", Helvetica, sans-serif;
  background-color: #eee;
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
}
body.detail {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat 0 0;
  background-size: 100%;
}

#root {
  height: 100%;
  width: 100%;
}

.loader {
  pointer-events: none;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
}
.loader img {
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  top: 50%;
  max-width: 50px;
  max-height: 50px;
}

.app {
  max-width: 420px;
  min-height: 100vh;
  overflow: hidden;
  margin: 0 auto;
  width: 100%;
  top: 0;
  background-size: cover;
  background-position: center;
}

.guide {
  position: absolute;
  width: 100%;
}

h2 {
  font: 3.3em/1 vigaregular;
}

h3 {
  font: 1.7em/1 vigaregular;
}

h5 {
  font: 1.3em/1 vigaregular;
}

.m-top-2 {
  margin-top: 2%;
}

.m-top-4 {
  margin-top: 4%;
}

.m-top-8 {
  margin-top: 8%;
}

.m-top-12 {
  margin-top: 12%;
}

.m-top-20 {
  margin-top: 20%;
}

.m-bottom-6 {
  margin-bottom: 6%;
}

.m-bottom-10 {
  margin-bottom: 10%;
}

.txt-center {
  text-align: center;
}

.txt-primary {
  color: #fff;
}

.link-primary {
  font: 1.3em/1 vigaregular;
  color: #fff;
  text-decoration: underline;
}

.btn-primary {
  border-radius: 5px;
  border: 2px solid #caa36c;
  background-color: #caa36c;
  color: #fff;
  cursor: pointer;
  display: block;
  font: 1.9em/1 vigaregular;
  padding: 6% 0;
  text-decoration: none;
  text-align: center;
}

.btn-secundary {
  background-color: #fff;
  border-radius: 5px;
  border: 2px solid #caa36c;
  font: 1.9em/1 vigaregular;
  color: #5c5c5c;
  cursor: pointer;
  display: block;
  padding: 6% 0;
  text-decoration: none;
  text-align: center;
}

.btn-tertiary {
  border-radius: 5px;
  border: 1px solid #caa36c;
  font: 1.4em/1 vigaregular;
  color: #caa36c;
  cursor: pointer;
  display: block;
  padding: 6% 0;
  text-decoration: none;
  text-align: center;
}

.button-upload-image {
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  border: 1px solid #caa36c;
  border-radius: 5px;
  padding: 4% 0 4%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.button-upload-image span {
  font: 1.2em/1.4em vigaregular;
  color: #caa36c;
}
.button-upload-image .remove {
  transform: translateY(-50%);
  position: absolute;
  width: 20px;
  right: 10px;
  top: 50%;
  text-decoration: none;
}
.button-upload-image .remove .icon-trash {
  font-size: 16px;
}
.button-upload-image .remove img {
  width: 100%;
}
.button-upload-image.upload {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center center;
}
.button-upload-image.upload span {
  visibility: hidden;
}

.footer-buttons {
  padding: 0 6%;
}

.options {
  display: flex;
  justify-content: space-between;
  max-width: 140px;
  width: 100%;
}
.options .option {
  background-color: #f5f5f5;
  border-radius: 5px;
  border: 0;
  color: #fff;
  font: 1.4em/1 vigaregular;
  color: #5c5c5c;
  transition: all 0.3s;
  padding: 25px 20px;
  cursor: pointer;
  flex-basis: 47%;
}
.options .option.selected {
  background-color: #caa36c;
  color: #fff;
}
.options.larger {
  max-width: 100%;
}
.options.larger.error {
  background-color: #fcdcdd;
  color: #eb6365;
}
.options.larger .option {
  padding: 22px 20px;
}

.popup .add-menu .row-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.popup .add-menu .row-checkbox .label-checkbox {
  font: 2em/1 vigaregular;
  color: #5c5c5c;
}
.popup .add-menu .row-checkbox input[type=checkbox] {
  background-color: #F2F2F2;
  color: #caa36c;
  border: none;
  border-radius: 6px;
  display: inline-block;
  width: 30px;
  height: 30px;
  padding: 0;
  margin-right: 15px;
  -webkit-appearance: none;
  position: relative;
}
.popup .add-menu .row-checkbox input[type=checkbox]:checked:after {
  content: "\\e90f";
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.MuiTableCell-root #react-qrcode-logo {
  width: 50px !important;
  height: 50px !important;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/core/1reset.scss","webpack://./src/styles/main.scss","webpack://./src/styles/core/2fonts.scss","webpack://./src/styles/core/4skeleton.scss","webpack://./src/styles/core/3colors.scss"],"names":[],"mappings":"AAAA;EAA2Z,SAAA;EAAS,UAAA;EAAU,SAAA;EAAS,eAAA;EAAe,wBAAA;ACMtc;;ADN8d;EAAE,sBAAA;EAAsB,kBAAA;EAAkB,UAAA;ACYxgB;;ADZkhB;EAA8E,cAAA;ACgBhmB;;ADhB8mB;EAAK,cAAA;EAAc,gBAAA;EAAgB,mCAAA;EAAmC,8BAAA;ACuBprB;;ADvBktB;EAAE,kBAAA;AC2BptB;;AD3BuuB;EAAM,gBAAA;AC+B7uB;;AD/B8vB;EAAY,mBAAA;ACmC1wB;;ACnCA;EACI,0BAAA;EACA,2DAAA;EACA,mBAAA;EACA,kBAAA;ADsCJ;ACnCA;EACI,sBAAA;EACA,4CAAA;EACA,mPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;ADkCJ;AC/BE;EACE,+EAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;ADgCJ;;AC7BE;EACE,cAAA;ADgCJ;;AC7BE;EACE,eAAA;ADgCJ;;AC5BE;EACE,gBAAA;AD+BJ;;AC7BE;EACE,gBAAA;ADgCJ;;AC9BE;EACE,gBAAA;ADiCJ;;AC/BE;EACE,gBAAA;ADkCJ;;AChCE;EACE,gBAAA;ADmCJ;;ACjCE;EACE,gBAAA;ADoCJ;;AClCE;EACE,gBAAA;ADqCJ;;ACnCE;EACE,gBAAA;ADsCJ;;ACpCE;EACE,gBAAA;ADuCJ;;ACrCE;EACE,gBAAA;ADwCJ;;ACtCE;EACE,gBAAA;ADyCJ;;ACvCE;EACE,gBAAA;AD0CJ;;ACxCE;EACE,gBAAA;AD2CJ;;ACzCE;EACE,gBAAA;AD4CJ;;AC1CE;EACE,gBAAA;AD6CJ;;AC3CE;EACE,gBAAA;AD8CJ;;AEvIA;EACI,YAAA;AF0IJ;;AExIA;EACI,4DAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AF2IJ;AEzII;EACI,iEAAA;EACA,qBAAA;AF2IR;;AEvIA;EACI,YAAA;EACA,WAAA;AF0IJ;;AEvIA;EACI,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;AF0IJ;AExII;EACI,gCAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AF0IR;;AEtIA;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,MAAA;EACA,sBAAA;EACH,2BAAA;AFyID;;AEtIA;EACI,kBAAA;EACA,WAAA;AFyIJ;;AArLA;EACI,yBAAA;AAwLJ;;AAtLA;EACI,yBAAA;AAyLJ;;AAvLA;EACI,yBAAA;AA0LJ;;AAxLA;EACI,cAAA;AA2LJ;;AAxLA;EACI,cAAA;AA2LJ;;AAxLA;EACI,cAAA;AA2LJ;;AAxLA;EACI,eAAA;AA2LJ;;AAxLA;EACI,eAAA;AA2LJ;;AAxLA;EACI,iBAAA;AA2LJ;;AAxLA;EACI,kBAAA;AA2LJ;;AAxLA;EACI,kBAAA;AA2LJ;;AAxLA;EACI,WGrCY;AHgOhB;;AAxLA;EACI,yBAAA;EACA,WG1CY;EH2CZ,0BAAA;AA2LJ;;AAxLA;EACI,kBAAA;EACA,yBAAA;EACA,yBG9CY;EH+CZ,WGlDY;EHmDZ,eAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;AA2LJ;;AAxLA;EACI,sBG5DY;EH6DZ,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cG9DS;EH+DT,eAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;AA2LJ;;AAxLA;EACI,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cGzEY;EH0EZ,eAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;AA2LJ;;AAxLA;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA2LJ;AA1LI;EACI,6BAAA;EACA,cAAA;AA4LR;AAzLI;EACI,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,qBAAA;AA2LR;AAzLQ;EACI,eAAA;AA2LZ;AAxLQ;EACI,WAAA;AA0LZ;AAtLI;EACI,2EAAA;AAwLR;AAtLQ;EACI,kBAAA;AAwLZ;;AAnLA;EACI,aAAA;AAsLJ;;AAnLA;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;AAsLJ;AApLI;EACI,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAsLR;AAnLQ;EACI,yBAAA;EACA,WAAA;AAqLZ;AAjLI;EACI,eAAA;AAmLR;AAjLQ;EACI,yBAAA;EACA,cAAA;AAmLZ;AAhLQ;EACI,kBAAA;AAkLZ;;AA5KA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AA+KJ;AA7KI;EACI,uBAAA;EACA,cAAA;AA+KR;AA5KI;EACI,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;AA8KR;AA1KY;EACI,gBAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AA4KhB;;AAnKA;EACI,sBAAA;EACA,uBAAA;EACA,eAAA;AAsKJ","sourcesContent":["a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font-size:100%;vertical-align:baseline}*{box-sizing:border-box;position:relative;outline:0}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1;font-weight:400;-webkit-font-smoothing:antialiased;-webkit-text-size-adjust:100%}i{font-style:normal;}ul,ol{list-style:none;}h1,h2,h3,h4{font-weight:normal}\n","// core\n@import 'core/1reset.scss';\n@import 'core/2fonts.scss';\n@import 'core/3colors.scss';\n@import 'core/4skeleton.scss';\n\n\nh2 {\n    font: 3.3em/1 vigaregular;\n}\nh3{\n    font: 1.7em/1 vigaregular;\n}\nh5{\n    font: 1.3em/1 vigaregular;\n}\n.m-top-2{\n    margin-top: 2%;\n}\n\n.m-top-4{\n    margin-top: 4%;\n}\n\n.m-top-8{\n    margin-top: 8%;\n}\n\n.m-top-12{\n    margin-top: 12%;\n}\n\n.m-top-20{\n    margin-top: 20%;\n}\n\n.m-bottom-6{\n    margin-bottom: 6%\n}\n\n.m-bottom-10{\n    margin-bottom: 10%;\n}\n\n.txt-center{\n    text-align: center;\n}\n\n.txt-primary{\n    color: $white-primary;\n}\n\n.link-primary{\n    font: 1.3em/1 vigaregular;\n    color: $white-primary;\n    text-decoration: underline;\n}\n\n.btn-primary{\n    border-radius: 5px;\n    border: 2px solid  $brown-primary;\n    background-color: $brown-primary;\n    color: $white-primary;\n    cursor: pointer;\n    display: block;\n    font: 1.9em/1 vigaregular;\n    padding: 6% 0;\n    text-decoration: none;\n    text-align: center;\n}\n\n.btn-secundary{\n    background-color: $white-primary;\n    border-radius: 5px;\n    border: 2px solid  $brown-primary;\n    font: 1.9em/1 vigaregular;\n    color: $black-grey;\n    cursor: pointer;\n    display: block;\n    padding: 6% 0;\n    text-decoration: none;\n    text-align: center;\n}\n\n.btn-tertiary{\n    border-radius: 5px;\n    border: 1px solid  $brown-primary;\n    font: 1.4em/1 vigaregular;\n    color:  $brown-primary;\n    cursor: pointer;\n    display: block;\n    padding: 6% 0;\n    text-decoration: none;\n    text-align: center;\n}\n\n.button-upload-image {\n    cursor: pointer;\n    text-decoration: none;\n    text-align: center;\n    border: 1px solid #caa36c;\n    border-radius: 5px;\n    padding: 4% 0 4%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    span {\n        font: 1.2em/1.4em vigaregular;\n        color: #caa36c ;\n    }\n\n    .remove {\n        transform: translateY(-50%);\n        position: absolute;\n        width: 20px;\n        right: 10px;\n        top: 50%;\n        text-decoration: none;\n\n        .icon-trash{\n            font-size: 16px;\n        }\n\n        img {\n            width: 100%;\n        }\n    }\n\n    &.upload {\n        background: url(../../public/images/loader-white.gif) no-repeat center center;\n\n        span {\n            visibility: hidden;\n        }\n    }\n}\n\n.footer-buttons{\n    padding: 0 6%;\n}\n\n.options {\n    display: flex;\n    justify-content: space-between;\n    max-width: 140px;\n    width: 100%;\n\n    .option {\n        background-color: #f5f5f5;\n        border-radius: 5px;\n        border: 0;\n        color: #fff;\n        font: 1.4em/1 vigaregular;\n        color: #5c5c5c;\n        transition: all 0.3s;\n        padding: 25px 20px;\n        cursor: pointer;\n        flex-basis: 47%;\n\n\n        &.selected {\n            background-color: #caa36c;\n            color: #fff;\n        }\n    }\n    \n    &.larger{\n        max-width: 100%;\n        \n        &.error{\n            background-color: #fcdcdd;\n            color: #eb6365;\n        }\n        \n        .option {\n            padding: 22px 20px;\n        }\n    }\n    \n}\n\n.popup .add-menu .row-checkbox{\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    \n    .label-checkbox{\n        font: 2em/1 vigaregular;\n        color: #5c5c5c;\n    }\n\n    input[type='checkbox'] {\n        background-color: #F2F2F2;\n        color: #caa36c;\n        border: none;\n        border-radius: 6px;\n        display: inline-block;\n        width: 30px;\n        height: 30px;\n        padding: 0;\n        margin-right: 15px;\n        -webkit-appearance: none;\n        position: relative;\n    \n        &:checked{\n    \n            &:after{\n                content: \"\\e90f\";\n                font-family: 'icomoon' !important;\n                speak: never;\n                font-style: normal;\n                font-weight: normal;\n                font-variant: normal;\n                text-transform: none;\n                line-height: 1;\n                -webkit-font-smoothing: antialiased;\n                -moz-osx-font-smoothing: grayscale;\n                position: absolute;\n                left: 50%;\n                top: 50%;\n                transform: translate(-50%, -50%);\n            }\n        }\n    }\n}\n\n\n\n\n.MuiTableCell-root #react-qrcode-logo{\n    width: 50px !important;\n    height: 50px !important;\n    cursor: pointer;\n}","@font-face {\n    font-family: 'vigaregular';\n    src: url('../../../public/css/fonts/Viga-Regular-webfont.woff') format('woff');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'icomoon';\n    src:  url('../../../public/css/fonts/icomoon.eot?r44a6r');\n    src:  url('../../../public/css/fonts/icomoon.eot?r44a6r#iefix') format('embedded-opentype'),\n      url('../../../public/css/fonts/icomoon.ttf?r44a6r') format('truetype'),\n      url('../../../public/css/fonts/icomoon.woff?r44a6r') format('woff'),\n      url('../../../public/css/fonts/icomoon.svg?r44a6r#icomoon') format('svg');\n    font-weight: normal;\n    font-style: normal;\n    font-display: block;\n  }\n  \n  [class^=\"icon-\"], [class*=\" icon-\"] {\n    /* use !important to prevent issues with browser extensions that change fonts */\n    font-family: 'icomoon' !important;\n    speak: never;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n  \n    /* Better Font Rendering =========== */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  .icon-back, .icon-arrow-back, .icon-config, .icon-drinks, .icon-theme, .icon-close{\n    color: #caa36c;\n  }\n\n  .icon-arrow-back{\n    font-size: 16px;\n  }\n\n\n  .icon-check:before {\n    content: \"\\e90f\";\n  }\n  .icon-edit-bold:before {\n    content: \"\\e90e\";\n  }\n  .icon-painting:before {\n    content: \"\\e90b\";\n  }\n  .icon-trash:before {\n    content: \"\\e90c\";\n  }\n  .icon-qrcode:before {\n    content: \"\\e90d\";\n  }\n  .icon-info:before {\n    content: \"\\e905\";\n  }\n  .icon-sort:before {\n    content: \"\\e906\";\n  }\n  .icon-close:before {\n    content: \"\\e907\";\n  }\n  .icon-arrow-back:before {\n    content: \"\\e908\";\n  }\n  .icon-edit:before {\n    content: \"\\e909\";\n  }\n  .icon-add:before {\n    content: \"\\e90a\";\n  }\n  .icon-theme:before {\n    content: \"\\e904\";\n  }\n  .icon-arrow-down:before {\n    content: \"\\e903\";\n  }\n  .icon-back:before {\n    content: \"\\e900\";\n  }\n  .icon-config:before {\n    content: \"\\e901\";\n  }\n  .icon-drinks:before {\n    content: \"\\e902\";\n  }\n  ","html {\n    height: 100%;\n}\nbody {\n    font: 62.5%/1 Arial, \"Helvetica Neue\", Helvetica, sans-serif;\n    background-color: #eee;\n    overflow-x: hidden;\n    overflow-y: auto;\n    height: 100%;\n\n    &.detail {\n        background: url(../../../public/images/background.png) no-repeat 0 0;\n        background-size: 100%;\n    }\n}\n\n#root {\n    height: 100%;\n    width: 100%;\n}\n\n.loader {\n    pointer-events: none;\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0;\n\n    img {\n        transform: translate(-50%, -50%);\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        max-width: 50px;\n        max-height: 50px;\n    }\n}\n\n.app {\n    max-width: 420px;\n    min-height: 100vh;\n    overflow: hidden;\n    margin: 0 auto;\n    width: 100%;\n    top: 0;\n    background-size: cover;\n\tbackground-position: center;\n}\n\n.guide {\n    position: absolute;\n    width: 100%;\n}\n","$lemon-primary: #ffd100;\n$lemon-secondary: #a36829;\n\n$raspberry-primary: #e51e45;\n$raspberry-secondary: #a32941;\n\n$passion-primary: #c80084;\n$passion-secondary: #86316e;\n\n$tangerine-primary: #f3881e;\n$tangerine-secondary: #a34029;\n\n$white-primary: #fff;\n$white-secundary: #f2f2f2;\n$black-grey: #5c5c5c;\n$brown-primary: #caa36c;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
